import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

import bgTranslations from './locales/bg.json'
import enTranslations from './locales/en.json'

const locales = {
    bg: bgTranslations,
    en: enTranslations
};

const currentLang = localStorage.getItem('app_lang') || 'bg';
window.__translations = locales[currentLang] || locales['bg'];
window.t = (key) => window.__translations?.[key] || key;

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
